import {
  IconConfetti,
  IconLogout,
  IconParachute,
  IconSettings,
} from '@tabler/icons-react'
import { Button } from './Button'
import { useAuth } from 'util/auth'
import { useRouter } from 'next/router'
import { useUserPlan } from 'hooks/useUserPlan'
import { seperateTextByCapital } from 'util/seperateTextByCapital'
import { useProjectStore } from 'store/useProjectStore'
import { PricingTableModal } from './PricingTableModal'

export const SidebarFooter = () => {
  const { plan, isTrialing, isInactive } = useUserPlan()
  const router = useRouter()
  const auth = useAuth()
  const { setShowUpgradeTrialModal, setShowPricingModal, showPricingModal } =
    useProjectStore()
  return (
    <div className=" space-y-4 rounded-lg py-4">
      <div className="flex w-full flex-col items-center justify-center gap-2">
        {(isTrialing || isInactive) && (
          <>
            <Button
              variant="outline"
              color="white"
              size="xs"
              icon={IconConfetti}
              className="duration-400 !hover:from-slate-500 !hover:to-toasty-blue-600 flex w-[10rem] items-center gap-2 rounded-md border !border-slate-500 !bg-gradient-to-r !from-toasty-blue-500 !to-slate-600 text-xs font-medium text-white transition-all hover:scale-105 hover:bg-gradient-to-l"
              onClick={() => {
                if (isTrialing) {
                  setShowUpgradeTrialModal(true)
                } else if (isInactive) {
                  setShowPricingModal(true)
                }
              }}
            >
              Upgrade Now
            </Button>
            {showPricingModal && (
              <PricingTableModal
                show="all"
                onSelectPlan={({ id }) => {
                  router.push(`/purchase?plan=${id}`)
                  setShowPricingModal(false)
                }}
                showPricingModal={showPricingModal}
                setShowPricingModal={setShowPricingModal}
                isLoading={false}
              />
            )}
          </>
        )}
        <Button
          variant="outline"
          color="blue"
          size="xs"
          className="w-[10rem]"
          icon={IconParachute}
          onClick={() => {
            // open a _blank tab to the latest updates
            window.open(
              'https://www.outcast.ai/toasty-v19-5-changelog/',
              '_blank'
            )
          }}
        >
          Changelog
        </Button>
        <Button
          variant="outline"
          color="white"
          size="xs"
          className="w-[10rem]"
          icon={IconSettings}
          onClick={() => {
            router.push('/settings')
          }}
        >
          Account Settings
        </Button>
        <Button
          variant="outline"
          size="xs"
          className="w-[10rem]"
          color="white"
          icon={IconLogout}
          onClick={() => {
            auth.signout()
            router.push('/login')
          }}
        >
          Logout
        </Button>
        <p className="mt-4 text-[10px] text-gray-600">
          Outcast {seperateTextByCapital(plan)}{' '}
          {isTrialing ? 'Free Trial' : 'plan'}
        </p>
      </div>
    </div>
  )
}
